import { AnimatedIllustrationWrapper } from '../AnimatedIllustrationWrapper';
import type { AnimatedIllustrationProps } from '../types';

export const ErrorAnimated = ({
  'aria-label': ariaLabel,
  ...props
}: AnimatedIllustrationProps) => {
  return (
    <AnimatedIllustrationWrapper
      src="https://static.mentimeter.com/static/images/animated_illustration_error.webp"
      type="spotlight"
      aria-label={ariaLabel || 'Error'}
      {...props}
    />
  );
};
